<template>
    <div>
        <div class="mb-4">
            <div class="row">
                <div class="col-12">
                    <!-- {{ fields }} -->
                    <div v-if="fields.length">
                        <div class="card card-inactive" v-for="(section, sectionIndex) in fields" :key="sectionIndex">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <h4 class="card-header-title">{{ section.label }}</h4>
                                    </div>
                                    <div class="col-auto">
                                        <button
                                            class="btn btn-primary btn-white ml-2"
                                            @click="section.idx = sectionIndex; openModal({ id: 'AddSectionModal', model: section });"
                                        >
                                            <i class="fe fe-edit"></i>
                                        </button>
                                        <button
                                            class="btn btn-primary btn-white ml-2"
                                            @click="section.idx=sectionIndex; openModal({id:'confirmationModal', model:section})"
                                        >
                                            <i class="fe fe-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="card" v-for="(field, key) in section.fields" :key="key">
                                    <div class="card-body">
                                        <div class="row align-items-center">
                                            <div class="col-auto draggable">
                                                <i class="fe fe-more-vertical"></i>
                                            </div>
                                            <div class="col ml-n2">
                                                <h4 class="card-title mb-1 name">{{ field.label }}</h4>
                                                <p class="card-text small text-muted mb-1">{{ field.name }}</p>
                                            </div>
                                            <div class="col ml-n2">{{ field.values }}</div>
                                            <div class="col-auto">{{ field.type }}</div>
                                            <div class="col-auto">
                                                <button
                                                    class="btn btn-primary btn-white ml-2"
                                                    @click="field.idx = key; openModal({ id: 'AddFieldModal', model: field });"
                                                >
                                                    <i class="fe fe-edit"></i>
                                                </button>
                                                <button
                                                    class="btn btn-primary btn-white ml-2"
                                                    @click="field.idx= key; openModal({id:'confirmationModal', model:field})"
                                                >
                                                    <i class="fe fe-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-2 text-center">
                                    <button
                                        class="btn btn-white ml-2"
                                        @click="openModal({id:'AddFieldModal', model:{sectionIndex}})"
                                    >
                                        <i class="fe fe-plus"></i> Add a field
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col"></div>
                            <div class="col-auto">
                                <button class="btn btn-white" @click="openModal({id:'AddSectionModal', model:{}})">
                                    <i class="fe fe-plus"></i>Add a section
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="card card-inactive" v-else>
                        <div class="card-body text-center">
                            <!-- Image -->
                            <img
                                src="@/assets/img/illustrations/scale.svg"
                                alt="..."
                                class="img-fluid"
                                style="max-width: 182px;"
                            />

                            <!-- Title -->
                            <h1>No fields yet.</h1>

                            <!-- Subtitle -->
                            <p class="text-muted">Define custom fields to expand your app.</p>

                            <!-- Button -->
                            <button
                                class="btn btn-primary mb-3"
                                @click="openModal({id:'AddSectionModal', model:{}})"
                            >Start declartion</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <renderer :fields="fields"></renderer>

        <add-field-modal id="AddFieldModal" :fields="fields" :initialData="model" :action="SaveField"></add-field-modal>
        <add-section-modal id="AddSectionModal" :initialData="model" :action="SaveSection"></add-section-modal>
        <confirmation-modal id="confirmationModal" :item="model" :confirmAction="deleteItem"></confirmation-modal>
    </div>
</template>

<script>
import Navigation from './Navigation.vue';
import Renderer from '@/components/Builder/Renderer.vue'
import AddFieldModal from '@/components/Builder/AddFieldModal.vue'
import AddSectionModal from '@/components/Builder/AddSectionModal.vue'
import ConfirmationModal from '@/components/ConfirmationModal.vue'
import { companyMixins } from './mixins.js'
import { modalMixins } from '@/mixins/modal.js'

export default {
    mixins: [companyMixins, modalMixins],
    components: {
        Renderer,
        Navigation,
        AddFieldModal,
        AddSectionModal,
        ConfirmationModal,
    },
    watch: {
        fields: {
            handler(newValue) {

                this.company.fields = newValue;
            },
            deep: true
        }
    },

    data() {
        return {
            loading: false,
            fields: [],

        };
    },

    created() {
        this.getMyCompany("mine").then(data => {
            this.fields = data.fields || [];
        });
    },
    methods: {
        SaveSection(field) {

            let idx;
            if (field.idx >= 0) {
                idx = field.idx;
            } else {
                field.fields = [];
                idx = this.fields.length;
            }
            this.fields.splice(idx, 1, field);

            this.saveCompany();

        },

        SaveField(field) {

            // let section = this.fields[field.sectionIndex].znothe = 1;
            let fields = this.fields[field.sectionIndex].fields;

            let idx = (field.idx >= 0) ? field.idx : fields.length;
            fields.splice(idx, 1, field);
            // this.$forceUpdate();
            this.saveCompany();

        },
        deleteItem(item) {

            if (item.sectionIndex >= 0) {
                this.fields[item.sectionIndex].fields.splice(item.idx, 1);
            } else {
                this.fields.splice(item.idx, 1);
            }
            this.saveCompany();
        }


    }
}
</script>

<style>
    .draggable {
        cursor: move;
    }
</style>

